module.exports = __webpack_public_path__ + "static/media/euro-sign.b8ba59c8.svg";